import apiService from '@/util/request.js';

/**
 * module that contains api functions for working with file server
 * @module storageApiService */

/**
 * fetch a file by id
 * @param {String} id file id
 * @returns {AxiosPromise<any>}
 */
const downloadFile = id => {
  return apiService.get(`/fileserver/resource/${id}/content`)
};

export default {
  downloadFile
}
